export const forceBackToCurrentLocation: boolean = true;
